import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { generateIdRoutePath } from '../../../helpers';
import { GAME_DB } from '../../../db/game';
const ContinueActiveGame = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content continue-active-game', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('continue_active_game'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: async () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                        const rally = await GAME_DB.GET.rallyInfo();
                        if (rally?.uuid) {
                            navigate(generateIdRoutePath(APP_ROUTES.rallyGameResult, String(rally.uuid)));
                        }
                    } }) })] }));
};
export default ContinueActiveGame;
